import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import Layout from "@/components/layout/Layout.vue";
import PublicLayout from "@/components/layout/PublicLayout.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if(to.hash) {
      return {selector: to.hash}  
    } return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "",
      component: Layout,
      children: [
        {
          path: "",
          name: "home",
          component: () => import("@/views/Home"),
        },
      ],
    },

    {
      path: "/compte",
      component: Layout,
      children: [
        {
          path: "",
          name: "compte",
          component: () => import("@/views/ProfileAccount"),
          meta: {
            publicOnly: false,
            breadcrumb: "Mon compte",
          },
        },
      ],
    },

    {
      path: "/connexion",
      component: Layout,
      children: [
        {
          path: "",
          name: "login",
          component: () => import("@/views/Login"),
          meta: {
            publicOnly: true,
            breadcrumb: "Connexion",
          },
        },
      ],
    },

    {
      path: "/forgot",
      component: Layout,
      children: [
        {
          path: "",
          name: "forgot",
          component: () => import("@/views/ForgotPassword"),
          meta: {
            publicOnly: false,
            breadcrumb: "Mot de passe oublié",
          },
        },
      ],
    },

    {
      path: "/produits",
      component: Layout,
      children: [
        {
          path: "",
          redirect: "/produits/",
          name: "products",
          component: () => import("@/views/AbstractRouterView"),
          meta: {
            breadcrumb: "Produits",
          },
          children: [
            {
              path: "/",
              component: () => import("@/views/Products"),
            },
            {
              path: ":id",
              name: "product",
              redirect: ":id/identite",
              component: () => import("@/views/Product"),
              props: true,
              meta: {
                breadcrumb: "Détail",
              },
              children: [
                {
                  path: "identite",
                  name: "productIdentity",
                  component: () => import("@/views/ProductIdentity"),
                  meta: {
                    label: "Identité",
                    authRequired: true,
                  },
                },
                {
                  path: "usages",
                  name: "productUses",
                  displayName: "Usages",
                  component: () => import("@/views/ProductUses"),
                  meta: {
                    label: "Usages",
                    authRequired: true,
                    query: { authorizations: ["authorized"] },
                  },
                },
                {
                  path: "classifications",
                  name: "productClassifications",
                  component: () => import("@/views/ProductClassifications"),
                  meta: {
                    label: "Classification",
                    authRequired: true,
                  },
                },
                {
                  path: "lmr",
                  name: "productLMR",
                  component: () => import("@/views/ProductLMR"),
                  meta: {
                    label: "LMR",
                    authRequired: true,
                  },
                },
                {
                  path: "*",
                  beforeEnter: (to, from, next) => {
                    store.commit("error/resourceNotFound", true);
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    {
      path: "/recherche-avancee-produits",
      component: Layout,
      children: [
        {
          path: "",
          redirect: "/recherche-avancee-produits/:results(results)?",
          name: "productsAdvancedSearch",
          component: () => import("@/views/AbstractRouterView"),
          meta: {
            breadcrumb: "Recherche avancée produits",
          },
          children: [
            {
              path: ":results(results)?",
              component: () =>
                import("@/views/ProductsAdvancedSearch/ProductsAdvancedSearch"),
            },
            {
              path: ":id",
              name: "productAdvancedSearch",
              redirect: ":id/identite",
              component: () => import("@/views/Product"),
              props: true,
              meta: {
                breadcrumb: "Détail",
              },
              children: [
                {
                  path: "identite",
                  name: "productIdentityAdvancedSearch",
                  component: () => import("@/views/ProductIdentity"),
                  meta: {
                    label: "Identité",
                    authRequired: true,
                  },
                },
                {
                  path: "usages",
                  name: "productUsesAdvancedSearch",
                  displayName: "Usages",
                  component: () => import("@/views/ProductUses"),
                  meta: {
                    label: "Usages",
                    authRequired: true,
                    query: { authorizations: ["authorized"] },
                  },
                },
                {
                  path: "classifications",
                  name: "productClassificationsAdvancedSearch",
                  component: () => import("@/views/ProductClassifications"),
                  meta: {
                    label: "Classification",
                    authRequired: true,
                  },
                },
                {
                  path: "*",
                  beforeEnter: (to, from, next) => {
                    store.commit("error/resourceNotFound", true);
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    {
      path: "/substances",
      component: Layout,
      children: [
        {
          path: "",
          redirect: "/substances/",
          name: "substances",
          component: () => import("@/views/AbstractRouterView"),
          meta: {
            breadcrumb: "Substances actives & Macro-organismes",
          },
          children: [
            {
              path: "/",
              component: () => import("@/views/Substances"),
            },
            {
              path: ":id",
              name: "substance",
              redirect: ":id/identite",
              component: () => import("@/views/Substance"),
              props: true,
              meta: {
                breadcrumb: "Détail",
              },
              children: [
                {
                  path: "identite",
                  name: "substanceIdentity",
                  component: () => import("@/views/SubstanceIdentity"),
                  meta: {
                    label: "Identité",
                    authRequired: true,
                  },
                },
                {
                  path: "proprietes",
                  name: "substanceProperties",
                  component: () => import("@/views/SubstanceProperties"),
                  meta: {
                    label: "Propriétés / mode d'action",
                    authRequired: true,
                  },
                },
                {
                  path: "classifications",
                  name: "SubstanceClassifications",
                  component: () => import("@/views/SubstanceClassifications"),
                  meta: {
                    label: "Classification",
                  },
                },
                {
                  path: "produits",
                  name: "substanceProducts",
                  component: () => import("@/views/SubstanceProducts"),
                  meta: {
                    label: "Produits",
                  },
                },
                {
                  path: "*",
                  beforeEnter: (to, from, next) => {
                    store.commit("error/resourceNotFound", true);
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    {
      path: "/recherche-avancee-substances",
      component: Layout,
      children: [
        {
          path: "",
          redirect: "/recherche-avancee-substances/:results(results)?",
          name: "substancesAdvancedSearch",
          component: () => import("@/views/AbstractRouterView"),
          meta: {
            breadcrumb:
              "Recherche avancée Substances actives & Macro-organismes",
          },
          children: [
            {
              path: ":results(results)?",
              component: () =>
                import(
                  "@/views/SubstancesAdvancedSearch/SubstancesAdvancedSearch"
                ),
            },
            {
              path: ":id",
              name: "substanceAdvancedSearch",
              redirect: ":id/identite",
              component: () => import("@/views/Substance"),
              props: true,
              meta: {
                breadcrumb: "Détail",
              },
              children: [
                {
                  path: "identite",
                  name: "substanceIdentityAdvancedSearch",
                  component: () => import("@/views/SubstanceIdentity"),
                  meta: {
                    label: "Identité",
                    authRequired: true,
                  },
                },
                {
                  path: "proprietes",
                  name: "substancePropertiesAdvancedSearch",
                  component: () => import("@/views/SubstanceProperties"),
                  meta: {
                    label: "Propriétés / mode d'action",
                    authRequired: true,
                  },
                },
                {
                  path: "classifications",
                  name: "SubstanceClassificationsAdvancedSearch",
                  component: () => import("@/views/SubstanceClassifications"),
                  meta: {
                    label: "Classification",
                    authRequired: true,
                  },
                },
                {
                  path: "produits",
                  name: "substanceProductsAdvancedSearch",
                  component: () => import("@/views/SubstanceProducts"),
                  meta: {
                    label: "Produits",
                  },
                },
                {
                  path: "*",
                  beforeEnter: (to, from, next) => {
                    store.commit("error/resourceNotFound", true);
                  },
                },
              ],
            },
          ],
        },
      ],
    },

    {
      path: "/actualites",
      component: Layout,
      children: [
        {
          path: "",
          component: () => import("@/views/AbstractRouterView"),
          redirect: "/actualites/",
          name: "news",
          meta: {
            breadcrumb: "Actualités",
          },
          children: [
            {
              path: "/",
              component: () => import("@/views/News"),
            },
            {
              path: ":slug",
              name: "article",
              component: () => import("@/views/Article"),
              props: true,
              meta: {
                breadcrumb: "Article",
              },
            },
          ],
        },
      ],
    },

    {
      path: "/faq",
      component: Layout,
      children: [
        {
          path: "",
          name: "faq",
          component: () => import("@/views/Faq"),
          meta: {
            breadcrumb: "FAQ",
          },
        },
      ],
    },

    {
      path: "/contact",
      component: Layout,
      children: [
        {
          path: "",
          name: "contact",
          component: () => import("@/views/Contact"),
          meta: {
            breadcrumb: "Contact",
          },
        },
      ],
    },

    {
      path: "/creation",
      component: Layout,
      children: [
        {
          path: "",
          name: "creation",
          component: () => import("@/views/Accountcreation"),
          meta: {
            breadcrumb: "Création de compte",
          },
        },
      ],
    },

    {
      path: "/recherche-generale",
      component: Layout,
      children: [
        {
          path: "",
          name: "generalSearch",
          component: () => import("@/views/GeneralSearch"),
          meta: {
            breadcrumb: "Recherche générale"
          },
        },
      ],
    },

    {
      path: "/mes-favoris",
      component: Layout,
      children: [
        {
          path: "",
          name: "favorites",
          component: () => import("@/views/Favorites"),
          meta: {
            breadcrumb: "Mes favoris",
            authRequired: true,
          },
        },
      ],
    },
    {
      path: "*",
      component: Layout,
      children: [
        {
          path: "",
          component: () => import("@/views/Flatpage"),
        },
      ],
    },
  ],
});


router.beforeResolve((to, from, next) => {
  if (store.state.error.resourceNotFound) {
    store.commit("error/resourceNotFound", false);
  }
  next();
});

router.beforeEach(async (to, from, next) => {
  const authenticated = store.getters["authent/isAuthenticated"];
  if (authenticated) {
    // check subscription
    await store.dispatch("authent/updateUser", {});
  }
  const isAuthRequired = !!to.meta.authRequired;
  const isPublicOnly = !!to.meta.publicOnly;

  if (isAuthRequired && !authenticated) {
    return next({
      name: "login",
      query: { redirect: to.fullPath },
    });
  } else if (authenticated && isPublicOnly) {
    return next({
      name: "home",
    });
  }
  next();
});

export default router;
